import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ permission }) {
  const { user, hasPermission } = useAuth();

  if (!user) return <Navigate to="/login" replace />;
  if (permission && !hasPermission(permission)) {
    return (
      <div className="p-10 text-center" data-testid="access-denied-message">
        <p className="font-heading text-xl text-[#2A211D]">You don't have access to this section.</p>
      </div>
    );
  }
  return <Outlet />;
}
